import React from 'react';
import { useAuth } from '../../hooks/auth';
import SuperAdminDashboard from '../../routes/super-admin/SuperAdminDashboard';
import StudentDashboard from '../../routes/student/StudentDashboard';
import { Navigate } from 'react-router';
import SchoolAdminDashboard from '../../routes/school-admin/SchoolAdminDashboard';
import { UserRole } from '../../types/auth';

const Dashboard = () => {
  const { user } = useAuth()!;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  switch (user.role) {
    case UserRole.SUPER_ADMIN:
      return <SuperAdminDashboard />;

    case UserRole.TEACHER:
      return <div></div>;

    case UserRole.STUDENT:
      return <StudentDashboard />;

    case UserRole.SCHOOL_ADMIN:
      return <SchoolAdminDashboard />;

    default:
      return <Navigate to="/login" replace />;
  }
}

export default Dashboard;